'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = {
  backgroundColor: 'inherit',
  float: 'left',
  color: 'white',
  border: 'none',
  width: '30px',
  height: '100%',
  cursor: 'pointer',
  textAlign: 'center',
  '&:focus': {
    outline: '0'
  },
  '& i': {
    borderRadius: '50%',
    fontSize: '22px',
    width: '30px'
  },
  '& i:before': {
    position: 'relative',
    bottom: '1px'
  }
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(_ref) {
  var iconStyle = _ref.iconStyle;
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _extends3.default)({
    '& i': (0, _extends3.default)({}, iconStyle, {
      padding: theme.paddingBase * 5 + 'px'
    })
  }, (0, _objectResolvePath2.default)(theme, 'IconButton.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/buttons/IconButton/IconButton.style.js
// module id = 345
// module chunks = 0